import { FieldInput } from '../../../../../../components/redux-form/fields/FieldInput';
import React from 'react';
import { change } from 'redux-form';
import { faMinusCircle, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './assets/substitution-form.module.scss';
import { FieldDropdown } from '../../../../../../components/redux-form/fields/FieldDropdown';

const RenderFieldArray = (props: any) => {
    const { fields, caseNumbers } = props;
    return (
        <ul className={classNames(styles.ul)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    caseNumbers={caseNumbers}
                    member={member}
                    fields={array}
                    index={index}
                />
            ))}
            <button type="button" onClick={() => fields.push({ status: 1 })}>
                Add
            </button>
        </ul>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    caseNumbers: { [key: string]: string | null }[];
};

const RenderSubFields: React.FunctionComponent<Props> = ({ member, index, fields, caseNumbers }) => {
    const dispatch = useDispatch();
    const row = fields.get(index);
    const deleteRow = () => {
        if (!row.id) {
            fields.remove(index);
        } else {
            dispatch(change('payment-form', `${member}.status`, 2));
        }
    };

    const backRow = () => {
        dispatch(change('payment-form', `${member}.status`, 1));
    };
    const creditStyle = {
        background: 'grey',
    };

    const arrCases: SelectObject[] = [];

    caseNumbers.forEach((it) => {
        if (it.caseNumber) {
            arrCases.push({ label: it.caseNumber, value: it.caseNumber });
        }
    });
    const isApplied: boolean = +row.status === 3;
    return (
        <li style={+row.status === 2 ? creditStyle : {}} className="d-flex flex-row w-100" key={index}>
            <FieldInput
                name={`${member}.amount`}
                type="number"
                disabled={isApplied}
                wrapperConfig={{
                    classes: { inputWrapper: 'mr-3 w-33' },
                    label: 'Amount, $:',
                }}
            />
            <FieldDropdown
                name={`${member}.caseNumber`}
                data={arrCases}
                dropUp={true}
                textField={'label'}
                disabled={isApplied}
                withSearchInput={true}
                valueField={'value'}
                wrapperConfig={{
                    classes: { inputWrapper: 'mr-3 w-33' },
                    label: 'Case Number:',
                }}
            />

            <FieldInput
                name={`${member}.comment`}
                disabled={isApplied}
                type="text"
                wrapperConfig={{
                    classes: { inputWrapper: 'mr-3 w-33' },
                    label: 'Comment: *',
                }}
            />
            {!isApplied ? (
                +row.status !== 2 ? (
                    <button type="button" className={'btn'} title="Remove Member" onClick={() => deleteRow()}>
                        <FontAwesomeIcon icon={faMinusCircle} />
                    </button>
                ) : (
                    <button type="button" className={'btn'} title="Remove Member" onClick={() => backRow()}>
                        <FontAwesomeIcon icon={faRedo} />
                    </button>
                )
            ) : (
                'Applied'
            )}
        </li>
    );
};
export default RenderFieldArray;
